import * as fontFamilies from '@/src/common/theme/fonts/fontFamilies'

// ensure the values are the same as their keys
fontFamilies satisfies { [key in keyof typeof fontFamilies]: key }

export { fontFamilies }

type DefaultFontLoadingGate = typeof import('@/src/common/theme/fonts/FontLoadingGate')
type WebFontLoadingGate = typeof import('@/src/common/theme/fonts/FontLoadingGate/index.web')

// if this check fails, we haven't ensured that `FontLoadingGate`'s exports have the same tyypes across mobile and web
true satisfies DefaultFontLoadingGate extends WebFontLoadingGate
  ? WebFontLoadingGate extends DefaultFontLoadingGate
    ? true
    : false
  : false
